import React from 'react';

export default React.createContext({
  changeUser: () => {},
  checkPermission: () => {},
  jwt: null,
  user: null,
});



// WEBPACK FOOTER //
// ./src/components/ComponentesAutenticacao/Provider.js